import { render, staticRenderFns } from "./AInscripcionEstado.vue?vue&type=template&id=ef2b2d36"
import script from "./AInscripcionEstado.vue?vue&type=script&lang=js"
export * from "./AInscripcionEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports